<template>
  <section class="vbox">    
    <section class="scrollable wrapper">
      <div class="content-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item><a href="/">营销</a></el-breadcrumb-item>
          <el-breadcrumb-item>抢购</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form ref="form" v-model="flashSale" label-width="160px">
        <el-form-item label="抢购名称">
          <el-col :span="11">
            <el-input v-model="flashSale.title" ></el-input>
          </el-col>
        </el-form-item>        
        <el-form-item label="产品">
          <el-col :span="11">
            <el-input v-model="productName" readonly placeholder="产品名称">
              <el-button slot="append" icon="el-icon-search" @click="ShowDialogProductSelect"></el-button>
            </el-input>   
          </el-col>
        </el-form-item>
        <el-form-item label="抢购价">
          <el-col :span="11">
            <el-input v-model="flashSale.flashPrice">              
              <el-button slot="append" >元</el-button>
            </el-input>
          </el-col>
        </el-form-item><el-form-item label="抽成">
          <el-col :span="11">
            <el-input v-model="flashSale.commission">           
              <el-button slot="append" >元</el-button>
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="总数量">
          <el-col :span="11">
            <el-input-number v-model="flashSale.totalCount" ></el-input-number>
          </el-col>
        </el-form-item>
        <el-form-item label="单人限购">
          <el-col :span="11">
            <el-input-number v-model="flashSale.limitCount" ></el-input-number>
          </el-col>
        </el-form-item>
        <el-form-item label="上架">
          <el-col :span="11">
            <el-switch
              v-model="flashSale.putOnShelves">
            </el-switch>
          </el-col>
        </el-form-item>
        <el-form-item label="开始时间">
          <el-col :span="11">
            <el-date-picker
              v-model="flashSale.beginTime"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-col :span="11">
            <el-date-picker
              v-model="flashSale.endTime"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="分享描述">
          <el-col :span="11">
            <el-input type="textarea" v-model="flashSale.shareDescription"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item >
          <el-col :span="11">
            <el-button type="primary" @click="SaveFlashSale">确 定</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </section>    
    <GetProduct v-bind:dialogProduct="dialogProduct" @UpdateProduct="UpdateProduct"></GetProduct>
  </section>
</template>
<script  type='text/ecmascript-6'>
  import GetProduct from '@/components/GetProduct'
  export default {
    props:{
    },
    data (){
      return {
        flashSale:{},
        productName:"",        
        dialogProduct:{
          isShow:false
        }
      }
    },
    components:{
      GetProduct
    },
    computed:{
    },
    mounted(){
      var that = this
      this.axios({
        method:'get',
        url:that.global.serverSrc + '/api/flashSale/Get',         
        params:{
          id:that.$route.params.Id
        }
      }).then(function (resp) {
        that.flashSale = resp.data.flashSale
        that.productName = resp.data.productName
      })
    },
    methods:{     
      SaveFlashSale:function(){
        var that = this
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/FlashSale/Save',         
          data:flashSale
        }).then(function (resp) {
          if(resp.data.errorCode==0){
            that.$message.success(resp.data.message);
          }else {
            that.$message.warning(resp.data.message);
          }  
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      UpdateProduct(id,name){
        this.flashSale.ProductId=id
        this.productName = name
        this.dialogProduct.isShow = false
      },
      ShowDialogProductSelect(){
        this.dialogProduct.isShow = true
      }
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
  .content-header
    padding 24px
    border 1px solid #C0C4CC
    margin-bottom 24px
</style>